module.exports = __webpack_public_path__ + "Lato-Light.ttf?90e1d3559ac52f7f0f77a86e1bfd632d";